import { render, staticRenderFns } from "./AddProductsDialog.vue?vue&type=template&id=0f6260a4"
import script from "./AddProductsDialog.vue?vue&type=script&lang=ts"
export * from "./AddProductsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports